(() => {
  if (window.__highSocietyCartCountSync) return;
  window.__highSocietyCartCountSync = true;

  function syncCount() {
    const source = document.querySelector('#amp-theme-extension .amp-cart__header-cart-count');
    if (!source) return;
    const count = Number.parseInt(source.textContent.trim(), 10);
    if (!Number.isInteger(count) || count < 0) return;

    document.querySelectorAll('.m-cart-icon-bubble').forEach((icon) => {
      const badge = icon.querySelector('.m-cart-count');
      if (!badge) return;
      const value = String(count);
      if (badge.textContent.trim() !== value) badge.textContent = value;
      badge.classList.toggle('m:hidden', count === 0);
      icon.setAttribute('aria-label', 'Panier : ' + count + ' article' + (count > 1 ? 's' : ''));
    });
  }

  let queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      syncCount();
    });
  }

  function start() {
    const root = document.getElementById('amp-theme-extension');
    if (!root) return false;
    new MutationObserver(queueSync).observe(root, {
      childList: true,
      characterData: true,
      subtree: true
    });
    queueSync();
    document.addEventListener('shopify:section:load', queueSync);
    return true;
  }

  function init() {
    if (start()) return;
    const pending = new MutationObserver(() => {
      if (start()) pending.disconnect();
    });
    pending.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
